module.exports = __webpack_public_path__ + "9c0c6a0cae6a2e7099d631ef5cfc4ae8.pdf";